var Model = require('../Model');

var ScheduledReport = Object.create(Model);

ScheduledReport.name = 'ScheduledReport';
ScheduledReport.url = 'scheduledreport';
ScheduledReport['@class'] = 'ScheduledReport';
ScheduledReport.fields = {
  name: {
    type: 'text',
    default: null,
    validators: {
      length: { minimum: 1, maximum: 128, default: '' }
    }
  },
  reportName: {
    default: null,
    hidden: true
  },
  reportType: {
    default: null,
    hidden: true
  },
  reportRid: {
    default: null,
    hidden: true
  },
  sourceKind: {
    default: null,
    hidden: true
  },
  targetKind: {
    default: null,
    hidden: true
  },
  targetRid: {
    default: null,
    hidden: true
  },
  targetClassName: {
    default: null,
    hidden: true
  },
  locationRid: {
    default: null,
    hidden: true
  },
  recordId: {
    default: null,
    hidden: true
  },
  params: {
    default: {},
    hidden: true
  },
  cron: {
    type: 'text',
    default: '0 8 * * *'
  },
  triggerType: {
    type: 'select',
    default: 'cron',
    options: [
      { name: 'Scheduled (cron)', value: 'cron' },
      { name: 'Event-based', value: 'event' }
    ]
  },
  timezone: {
    type: 'text',
    default: 'America/New_York'
  },
  format: {
    type: 'select',
    default: 'pdf',
    options: [
      { name: 'PDF', value: 'pdf' },
      { name: 'Excel', value: 'xlsx' },
      { name: 'JSON', value: 'json' }
    ]
  },
  deliveryMethod: {
    type: 'select',
    default: 'link',
    options: [
      { name: 'Email link', value: 'link' },
      { name: 'Email attachment', value: 'attachment' },
      { name: 'OneDrive folder', value: 'onedrive' }
    ]
  },
  oneDriveFolder: {
    type: 'text',
    default: null
  },
  endAt: {
    default: null,
    hidden: true
  },
  initialLookbackDays: {
    default: null,
    hidden: true
  },
  initialRunStatus: {
    default: null,
    hidden: true
  },
  initialRunRequestedAt: {
    default: null,
    hidden: true
  },
  initialRunStartedAt: {
    default: null,
    hidden: true
  },
  initialRunCompletedAt: {
    default: null,
    hidden: true
  },
  initialRunAttempts: {
    default: 0,
    hidden: true
  },
  initialRunNextAttemptAt: {
    default: null,
    hidden: true
  },
  scheduleEnabled: {
    default: true
  },
  notifyOnNewEvents: {
    default: false
  },
  groups: {
    default: [],
    hidden: true
  },
  enabled: {
    default: true
  },
  lastRunAt: {
    default: null,
    hidden: true
  },
  lastRunStatus: {
    default: null,
    hidden: true
  },
  lastRunMessage: {
    default: null,
    hidden: true
  },
  lastReportFilename: {
    default: null,
    hidden: true
  },
  lastReportFilenames: {
    default: [],
    hidden: true
  },
  lastDeliveryUrls: {
    default: [],
    hidden: true
  },
  lastEventScanAt: {
    default: null,
    hidden: true
  },
  eventNotificationState: {
    default: {},
    hidden: true
  }
};

module.exports = ScheduledReport;
